import { useContext, useEffect, useState } from 'react'
import { AdminContext } from '../../context/admin.context'
import { LoginPage } from '..'
import api from '../../api/index.api'
import { DashboardCommon, LoadingCommon } from '../../common'
import { withRouter } from 'react-router-dom'

const AdminAuthComponent = ({ children }) => {
	const [adminContext, setAdminContext] = useContext(AdminContext)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const getProfileAdmin = async () => {
			const profile = await api.userApi.getProfile()
			if (profile.roleMap.admin) {
				setAdminContext(profile)
				setIsLoading(false)
			}
		}
		getProfileAdmin()
			.then(() => setIsLoading(false))
			.catch(() => setIsLoading(false))
	}, [setAdminContext])

	if (isLoading) {
		return <LoadingCommon size="large" isFullHeight />
	} else {
		if (adminContext) return <DashboardCommon>{children}</DashboardCommon>
		else return <LoginPage />
	}
}

export const AdminAuth = withRouter(AdminAuthComponent)
